import React, { Fragment } from 'react'
import classnames from 'classnames'

import { groupBookingsByDay } from '../../actions/update-enrolment-schedule'
import SessionsForWeek from './sessions-for-week'
import './booking-schedule.css'

const BookingSchedule = ({ week1, week2, compact = false, showWarningFun }) => {
  if (!week1) {
    return null
  }

  return (
    <div className={classnames({ enrolmentSchedule: true, enrolmentSchedule__compact: compact })}>
      {week2 && <h3 className="enrolmentSchedule--weekNo">Week 1</h3>}
      <SessionsForWeek
        compact={compact}
        weeklySessions={groupBookingsByDay(week1)}
        showWarningFun={showWarningFun}
      />

      {week2 && (
        <Fragment>
          <h3 className="enrolmentSchedule--weekNo">Week 2</h3>
          <SessionsForWeek
            compact={compact}
            weeklySessions={groupBookingsByDay(week2)}
            showWarningFun={showWarningFun}
          />
        </Fragment>
      )}
    </div>
  )
}

export default BookingSchedule



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/booking-schedules/views/index.jsx